import * as React from 'react';
import { Controller, Toolbar, MainMenu, Menu } from '@tencent/workbench';
import { RotateFeature } from './rotate-feature';
import { FLIP_HORIZONTAL_CONFIG, FLIP_VERTICAL_CONFIG, MENU_CONFIGS, ROTATE_LEFT_90_CONFIG, ROTATE_RIGHT_90_CONFIG, TOOLBAR_ITEMS, config } from './config';


@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class RotateController {
    constructor(private readonly feature: RotateFeature) {
    }

    @Toolbar(config.id, 'dropdownContent')
    public getPcBtnDropdownContent() {
        return <MainMenu align="left" name={config.id} mode="menu"/>;
    }

    @Toolbar(config.id, 'onDropdownVisibleChange')
    public onDropdownVisibleChange(visible: boolean) {
        this.feature.updateDropdownVisible(visible, config.id);
    }

    @Menu(ROTATE_RIGHT_90_CONFIG.name, 'onClick')
    public rotateRight90() {
        this.feature.rotateRight90();
    }

    @Menu(ROTATE_LEFT_90_CONFIG.name, 'onClick')
    public rotateLeft90() {
        this.feature.rotateLeft90();
    }

    @Menu(FLIP_VERTICAL_CONFIG.name, 'onClick')
    public flipVertical() {
        this.feature.flipVertical();
    }

    @Menu(FLIP_HORIZONTAL_CONFIG.name, 'onClick')
    public flipHorizontal() {
        this.feature.flipHorizontal();
    }
}
